<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative">
    <div class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton"
        :color="navbarColorLocal"
        :class="textColor"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer p-2 mr-2"
          icon="MenuIcon"
          @click.stop="showSidebar"
        />
        
        <!-- <config-dash-board
          class="md:hidden"
          v-if="routeTitle === 'Dashboard'"
        /> -->
        

        <!-- <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" /> -->
        <transition :name="routerTransition">
          <div
            v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
            class="router-header flex flex-wrap items-center md:flex flex-1"
          >
            <!--breadcrumb---
               :class="{
                'pr-4 border-0 md:border-r border-solid border-grey-light':
                  $route.meta.breadcrumb,
              }" -->

            <div class="content-area__heading flex items-center xl:flex hidden">
              <h3 class="mb-1 mr-2 pr-2 flex relative">{{ routeTitle }}</h3>
            </div>

              <div v-if="routeTitle === 'Configure Dashboard'" class="flex items-center">
                <config-dash-board v-if="routeTitle === 'Configure Dashboard'" class="mx-2" />
                
                <div class="flex">
                  <div class="custom-btn cursor-pointer px-3 px-lg-5 py-2 text-center"
                    @click="$store.commit('dashboard/SHOW_WIDGETS_CARD', true)"
                  >
                      &#43; Add
                  </div>
                  <div class="custom-btn cursor-pointer px-3 px-lg-5 py-2 text-center my-2 sm:my-0"
                    @click="resetWidgets()"
                  >
                      &#10227; Reset
                  </div>
                  <div class="custom-btn cursor-pointer px-3 px-lg-5 py-2 text-center"
                      @click="$store.commit('dashboard/SET_CONFIG_DASHBOARD', false)"
                    >
                      &#10003; Done
                  </div>
                </div>
              </div>
            <!-- <div
              ref="notificationpanel"
              v-if="
                appSubscriptions.coach ||
                appSubscriptions.journey ||
                appSubscriptions.alex
              "
              class="mt-2 relative"
            >
              <img
                class="w-8 cursor-pointer"
                src="@/assets/images/icons/bell.svg"
                alt="Bell"
                @click="
                  $store.commit(
                    'modals/OPEN_NOTIFICATION_POPUP',
                    !notificationPanelPopup
                  )
                "
              />
              <notification v-show="notificationPanelPopup" />
            </div> -->

            <!-- BREADCRUMB -->
            <!-- removed breadcrumb temp  -->
            <!-- <vx-user-breadcrumb
              class="ml-4 md:block hidden"
              v-if="$route.meta.breadcrumb"
              :route="$route"
              :isRTL="$vs.rtl"
            /> -->
            <!-- <div class="vx-card ml-auto p-3 items-right" style="width: auto;">
                    <profile-drop-down />
                  </div> -->
          </div>
        </transition>
        <!-- <i18n /> -->

        <!-- <search-bar /> -->

        <!-- <cart-drop-down /> -->

        <!-- Notification Icon show -->
        <div
          class="mt-2 p-2 mx-2"
          ref="notificationpanelSmall"
          v-if="
            appSubscriptions.coach ||
            appSubscriptions.journey ||
            appSubscriptions.alex
          "
        >
          <img
            class="w-8 cursor-pointer"
            src="@/assets/images/icons/bell.svg"
            alt="Bell"
            @click="
              $store.commit(
                'modals/OPEN_NOTIFICATION_POPUP',
                !notificationPanelPopup
              )
            "
          />
          <notification v-show="notificationPanelPopup" />
        </div>
        <!-- Notification Icon End Here -->

        <apps-drop-down class="p-2 mx-2" />

        <!-- <profile-drop-down class="md:hidden" /> -->

        <div class="ml-2 p-2 items-right md:flex" style="width: auto">
          <profile-drop-down />
        </div>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import Bookmarks from "./components/Bookmarks.vue";
// import I18n                 from './components/I18n.vue'
import SearchBar from "./components/SearchBar.vue";
// import CartDropDown         from './components/CartDropDown.vue'
import NotificationDropDown from "./components/NotificationDropDown.vue";
import AppsDropDown from "./components/AppsDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";
import themeConfig from "@/../themeConfig.js";
import VxUserBreadcrumb from "../VxUserBreadcrumb.vue";
import ConfigDashBoard from "./components/ConfigDashBoard.vue";
import Notification from "./components/Notification.vue";

export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      routerTransition: themeConfig.routerTransition || "none",
      // routeTitle        : this.$route.meta.pageTitle
      configUserDashboard: false,
      showConfigIconTip: false,
    };
  },

  components: {
    Bookmarks,
    // I18n,
    SearchBar,
    // CartDropDown,
    NotificationDropDown,
    ProfileDropDown,
    VxUserBreadcrumb,
    AppsDropDown,
    ConfigDashBoard,
    Notification,
  },
  computed: {
    routeTitle() {
      return this.$route.meta.pageTitle;
    },
    usersData() {
      return this.$store.state.users.data;
    },
    navbarColorLocal() {
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff"
        ? "#10163a"
        : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return {
        "text-white":
          (this.navbarColor !== "#10163a" &&
            this.$store.state.theme === "dark") ||
          (this.navbarColor !== "#fff" && this.$store.state.theme !== "dark"),
      };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth === "default") return "navbar-default";
      else if (this.verticalNavMenuWidth === "reduced") return "navbar-reduced";
      else if (this.verticalNavMenuWidth) return "navbar-full";
    },
    userBoards() {
      return this.$store.state.boards.userLevelBoards;
    },
    notificationPanelPopup() {
      return this.$store.state.modals.notificationPanelPopup;
    },
    appSubscriptions() {
      return this.$store.state.users.appSubscriptions;
    },
    configDashboard() {
      return this.$store.state.dashboard.configDashboard;
    },
  },
  watch: {
    configUserDashboard(val) {
      this.$store.commit("dashboard/SET_CONFIG_DASHBOARD", val);
    },
    notificationPanelPopup(newVal) {
      if (newVal) {
        window.addEventListener("click", this.handleClickOutside);
      }
    },
  },
  methods: {
    resetWidgets() {
      this.$root.$refs.Main.setDefaultDashboardConfig();
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },
    handleClickOutside(event) {
      var deviceWidth = window.innerWidth;
      const popup =
        deviceWidth >= 768
          ? this.$refs.notificationpanel
          : this.$refs.notificationpanelSmall;
      if (!popup.contains(event.target)) {
        this.$store.commit("modals/OPEN_NOTIFICATION_POPUP", false);
        window.removeEventListener("click", this.handleClickOutside);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.blinker {
  top: 0.75em;
  right: -0.5em;
  &-color {
    background: rgba(var(--vs-primary, "#F2C244"), 1) !important;
  }
  &-details {
    background: #fae0a0;
    left: 6em;
    top: 2em;
    width: 20em;
    border-radius: 8px;
  }
}
@media (min-width: 1201px) {
  .main-vertical .vx-navbar-wrapper {
    /* width: calc(100% - 260px); */
    /* width: 100%; */
    /* padding-left: calc(100% - 500px); */
  }

  /* .vs-navbar {
    background: #F8F8F8 !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    opacity: 1;
  } */

  .navbar-floating .vx-navbar {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
